module.exports = __webpack_public_path__ + "static/media/really.1f636cba.jpg";